import { component$, Slot } from "@builder.io/qwik";
import { Card, CardContent } from "./card";
import { Link } from "@builder.io/qwik-city";
import { Button, type ButtonProps } from "./button";

interface CTASectionProps {
  title?: string;
  description?: string;
  link?: string;
  linkText?: string;
  track?: ButtonProps["track"];
}

export const CTASection = component$<CTASectionProps>(
  ({ title, description, link, linkText, track }) => {
    return (
      <Card class="shadow-purple-700/8 border-purple-300/50 bg-gradient-to-br from-purple-100 via-violet-100 to-purple-200">
        <CardContent class="mx-auto w-full p-8 py-12 text-center">
          <div class="mx-auto max-w-md">
            {title && (
              <h2 class="font-heading text-primary text-2xl font-medium tracking-tight">
                {title}
              </h2>
            )}
            {description && (
              <p class="text-secondary mt-2 leading-normal">{description}</p>
            )}
          </div>
          <Slot />
          {link && linkText && (
            <Link href={link} class="mt-6 block w-full text-center">
              <Button variant="fancy" size="lg" track={track}>
                {linkText}
              </Button>
            </Link>
          )}
        </CardContent>
      </Card>
    );
  },
);
